<div class="filter-box__shell" [@expandir]="estadoAnimacao()">
  <div class="filter-box__panel">
    <h3 class="filter-box__heading">Filtrar resultados</h3>
    <div class="filter-box__fields">
      <ng-content></ng-content>
    </div>
    <div class="filter-box__footer">
      <ng-content select="[filter-box-footer-extras]"></ng-content>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onAplicar()"
      >
        <mat-icon>filter_list</mat-icon>
        Filtrar
      </button>
    </div>
  </div>
</div>
